import React from 'react';
import { useField } from 'formik';
import ToggleButton from 'react-bootstrap/ToggleButton';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import NumberFormat from 'react-number-format';

export const mapping = {
  metricUnit: { label: 'cm', value: 'cm' },
  imperialUnit: {
    label: 'ft,in',
    value: 'feet',
    labels: { feet: 'ft', inches: 'in' }
  }
};

export default function HeightField({
  cmFieldName,
  cmPlaceholder = '00',
  feetFieldName,
  feetPlaceholder = '0',
  inchFieldName,
  inchPlaceholder = '0',
  unitFieldName
}) {
  const [unitField] = useField(unitFieldName);

  return (
    <div className="form-group form-group-height">
      <label className="form-label form-label-lg">Height</label>
      {unitField.value === mapping.metricUnit.value ? (
        <MetricHeightField
          fieldName={cmFieldName}
          placeholder={cmPlaceholder}
        />
      ) : unitField.value === mapping.imperialUnit.value ? (
        <ImperialHeightField
          feetPlaceholder={feetPlaceholder}
          feetFieldName={feetFieldName}
          inchPlaceholder={inchPlaceholder}
          inchFieldName={inchFieldName}
        />
      ) : null}

      <HeightUnitToggle fieldName={unitFieldName} />
    </div>
  );
}

function HeightUnitToggle({ fieldName }) {
  const [field, meta] = useField(fieldName);

  return (
    <div className="default-btn-toolbar default-btn-toolbar-sm">
      <ButtonToolbar>
        <ToggleButtonGroup
          type="radio"
          defaultValue={meta.initialValue}
          {...field}
        >
          <ToggleButton {...field} value={mapping.imperialUnit.value}>
            {mapping.imperialUnit.label}
          </ToggleButton>

          <ToggleButton {...field} value={mapping.metricUnit.value}>
            {mapping.metricUnit.label}
          </ToggleButton>
        </ToggleButtonGroup>
      </ButtonToolbar>
    </div>
  );
}

function FieldError({ meta }) {
  return meta.touched && meta.error ? (
    <div className="input-feedback">{meta.error}</div>
  ) : null;
}

function MetricHeightField({ placeholder, fieldName }) {
  const [field, meta] = useField(fieldName);

  return (
    <div className="form-inline unit-field">
      <NumberFormat
        type="text"
        allowNegative={false}
        className="form-control"
        placeholder={placeholder}
        {...field}
      />
      <span>{mapping.metricUnit.label}</span>
      <FieldError meta={meta} />
    </div>
  );
}

function ImperialHeightField({
  feetPlaceholder,
  feetFieldName,
  inchPlaceholder,
  inchFieldName
}) {
  const [feetField, feetMeta] = useField(feetFieldName);
  const [inchField, inchMeta] = useField(inchFieldName);

  return (
    <div className="feet-inch-form">
      <div className="form-inline unit-field">
        <NumberFormat
          type="text"
          allowNegative={false}
          decimalSeparator={false}
          className="form-control"
          placeholder={feetPlaceholder}
          {...feetField}
        />
        <span>{mapping.imperialUnit.labels.feet}</span>
        <FieldError meta={feetMeta} />
      </div>

      <div className="form-inline unit-field">
        <NumberFormat
          type="text"
          allowNegative={false}
          decimalSeparator={false}
          className="form-control"
          placeholder={inchPlaceholder}
          {...inchField}
          isAllowed={values => values.value === '' || values.floatValue <= 11}
        />
        <span>{mapping.imperialUnit.labels.inches}</span>
        <FieldError meta={inchMeta} />
      </div>
    </div>
  );
}
